<template>
  <div class="eid-preview-wrap">
    <a-spin :spinning="spinning">
      <pageTitle />
      <div class="page-main">
        <a-row :gutter="16">
          <a-col :span="12">
            <div class="video-title">
              <p class="title">名称 :</p>
              <input
                style="width: 373px"
                readonly
                class="bb1 question_detail_page_help"
                placeholder="请输入名称"
                v-model="title"
              />
            </div>
            <div class="video-title">
              <p class="title">视频 :</p>
              <!--          <canvas id="canvas" style="display: none" />-->

              <div v-if="!spinning">
                <video-player
                  class="video-player vjs-custom-skin"
                  ref="videoPlayer"
                  :playsinline="true"
                  :options="playerOptions"
                >
                </video-player>
                <!--            <video-->
                <!--              ref="video"-->
                <!--              controls-->
                <!--              preload-->
                <!--              crossorigin="anonymous"-->
                <!--              :src="tutorialInfo.tutorialVideoUrl"-->
                <!--              :poster="tutorialInfo.videoCover" />-->
                <br />
                <!--            <a-button type="primary" icon="delete" @click="remove">删除</a-button>-->
              </div>
            </div>
            <a-table
              :columns="columns"
              :total="pagination.total"
              :pagination="pagination"
              :loading="loading"
              rowKey="commentId"
              @change="handleTableChange"
              :dataSource="dataSource"
            >
              <template slot="avatar" slot-scope="text, record">
                <viewer :images="[record.avatar]">
                  <a-avatar :src="record.avatar" size="large" />
                </viewer>
              </template>
              <template slot="showStatus" slot-scope="text, record">
                {{ Boolean(record.showStatus) ? "正常" : "已屏蔽" }}
              </template>
              <template slot="action" slot-scope="text, record, index">
                <a-button type="link" @click="statusChange(record, index)">
                  {{ Boolean(record.showStatus) ? "屏蔽" : "恢复" }}
                </a-button>
              </template>
            </a-table>
          </a-col>
          <a-col :span="12">
            <div class="">
              <p class="title mt25" style="display: block">教程详情:</p>
              <div class="eid-preview">
                <div class="preview">
                  <div class="preview-header" />
                  <div v-html="content" class="content-html" />
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </a-spin>
  </div>
</template>

<script>
import pageTitle from "@/components/business/pageTitle";
import businessGroup from "@/components/business/businessGroup";
import { tips } from "@/utils/util";
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";

export default {
  components: {
    pageTitle,
    videoPlayer,
    businessGroup,
  },
  // props: {
  //   detailsUrl: undefined,
  //   saveUrl: undefined
  // },
  data() {
    return {
      title: undefined,
      content: undefined,
      detailsUrl: "bluetoothlight/web/other/tutorials/",
      spinning: false,

      tutorialInfo: undefined,
      playerOptions: {
        height: "400",
        width: "373",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        // fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        // flash: { hls: {withCredentials: false} }, // 可以使用rtmp视频
        // html5: { hls: {withCredentials: false} }, // 可以使用m3u8视频
        loop: false,
        sources: [
          {
            type: "video/mp4", // 类型
            src: "", // url地址
          },
        ],
        poster: "",
        language: "zh-CN",
      },

      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      columns: [
        {
          title: "用户头像",
          dataIndex: "avatar",
          key: "avatar",
          align: "center",
          width: 100,
          scopedSlots: { customRender: "avatar" },
        },
        {
          title: "用户昵称",
          dataIndex: "nickname",
          key: "nickname",
          align: "center",
          width: 100,
        },
        {
          title: "分享内容",
          dataIndex: "commentContent",
          key: "commentContent",
          align: "center",
        },
        {
          title: "状态",
          dataIndex: "showStatus",
          key: "showStatus",
          align: "center",
          scopedSlots: { customRender: "showStatus" },
          width: 100,
        },
        {
          title: "操作",
          scopedSlots: { customRender: "action" },
          align: "center",
          width: 100,
        },
      ],
      dataSource: [],
      loading: false,
      no: false,
    };
  },
  created() {
    const { tutorialId } = this.$route.query;
    this.detailsUrl = `${this.detailsUrl}${tutorialId}`;
    if (tutorialId) {
      this.getDetail(this.detailsUrl);
    }
  },

  methods: {
    /**
     *  获取详情
     *  @param {String} url 请求路径
     *  @param {Object} data 请求参数
     *  分别处理 图文 和 视频
     *  视频 editType === video
     * */
    getDetail: async function (url, data) {
      if (!this.no) {
        this.spinning = true;
      }

      const { pageSize, current } = this.pagination;
      const res = await this.$get(url, {
        ...(data || {}),
        pageNo: current,
        pageSize,
      });
      const resultData = res?.resultData;
      if (!resultData) return false;

      const { tutorialInfo = {}, commentTotal = 0 } = resultData;
      this.dataSource = resultData?.comments || [];

      this.pagination.total = commentTotal;
      if (!this.no) {
        const { tutorialVideoUrl, videoCover, tutorialName, tutorialDetail } = tutorialInfo;

        this.title = tutorialName;
        this.content = tutorialDetail;

        this.playerOptions.poster = videoCover;
        this.playerOptions.sources[0].src = tutorialVideoUrl;

        // this.tutorialInfo = resultData?.tutorialInfo;
        this.show = true;
        this.spinning = false;
      }

      this.no = true;
    },
    statusChange: function (record, index) {
      let that = this;
      this.$confirm({
        title: "是否更改状态?",
        okText: "确认",
        cancelText: "取消",
        //maskClosable: false,
        async onOk() {
          const { commentId } = record;
          if (that.loading) return false;
          that.loading = true;
          const res = await that.$put(
            `/bluetoothlight/web/other/tutorial/comments/${commentId}/show`
          );
          that.loading = false;
          tips(that, res.resultStatus, res.errorMessage);
          // this.dataSource[inddex] = true
          that.getDetail(that.detailsUrl);
        },
        onCancel() {
          that.$message.warning("取消操作");
        },
      });
    },
    handleTableChange(pagination = {}) {
      const { current = 1, pageSize = 10 } = pagination;
      console.log(pagination);
      this.pagination.current = current;
      this.pagination.pageSize = pageSize;
      this.getDetail(this.detailsUrl);
    },
    cancel() {
      this.$message.warning("取消更改。");
    },
  },
};
</script>


<style lang="less">
.eid-preview-wrap {
  width: 100%;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  //display: flex;
  background: #fff;
  padding: 10px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  //overflow: auto;
  height: 100%;

  .video-player {
    height: 400px;
    width: 375px;
  }

  .title {
    display: inline-block;
    font-size: 18px;
    padding: 10px 0;
  }

  .bb1 {
    border-bottom: 1px solid #ccc;
  }

  .mt25 {
    margin-top: 25px !important;
  }

  .eid-preview {
    min-height: calc(100% - 164px);

    .preview {
      width: 375px;
      min-height: calc(100% - 164px);
      border: 1px solid #ccc;
    }

    .preview-header {
      height: 88px;
      background-image: url("../../../assets/img/phone_header.png");
      background-repeat: no-repeat;
    }

    .content-html {
      word-wrap: break-word;
      word-break: break-all;
      font-size: 14px;
      font-weight: 500;

      line-height: 28px;
      color: #333;
      width: 100%;
      padding: 0 20px 10px 20px;
      text-align: left;
      min-height: 150px;
      //min-height: calc(100% - 50px);
      //div {
      //  //width: 100%;
      //  overflow-y: scroll;
      //
      //}
      iframe {
        width: 100%;
      }
    }
  }

  //.eid {
  //  min-height: 400px;
  //}
  .video-title {
    display: flex;
    margin-top: 15px;
    font-size: 18px;

    .title {
      flex: 0 0 150px;
    }
  }
}

.eid-preview {
  display: flex;
  justify-content: space-between;

  .preview,
  .eid {
    width: 55%;
  }

  .w-e-text {
    padding-top: 10px;
  }

  .eid {
    .saveBtn {
      display: block;
      margin: 0 auto;
      margin-top: 30px;
    }
  }
}

.question_detail_page {
  .header {
    height: 50px;
    font-size: 24px;
    font-weight: 500;
    border-bottom: 2px solid #eee;
    margin-left: 5px;
  }

  &_help {
    background: none;
    //border-top: none;
    //border-left: none;
    //border-right: none;
    border: none;
    //width: 500px;
    outline: none;
  }

  .answer {
    display: flex;
    width: 80%;
    margin: 0 auto;
    flex-direction: row;
    //justify-content: space-between;
    justify-content: space-evenly;

    .content {
      display: flex;
      flex-direction: column;
      text-align: center;
      width: 40%;
      padding: 10px;
      box-sizing: border-box;

      &_msg {
        width: 100%;
        min-height: 300px;
        border: 2px solid #eee;
        padding: 10px;

        &_header {
          padding: 10px;
          width: 100%;
          font-size: 10px;
        }

        &_pic {
          //width: 80%;

          height: 200px;
          background-color: #d9d9d9;
          margin: 10px;
        }
      }

      &_edit {
        width: 100%;
        height: 300px;
        margin-top: 10px;
        padding: 10px;
        box-sizing: border-box;
        border: 2px solid #eee;
        text-align: left;
        // .avatar-uploader{
        //     width: 200px;
        // }
      }
    }
  }
}
</style>
